import { render } from "./DataTable.vue?vue&type=template&id=3c35d5e7"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
script.render = render

export default script